import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Message, Paginated } from '@haleo-frontend/data-access/models';
import { EnvironmentUtils } from '@haleo-frontend/utils';

import { MessageStatusEnum } from '../enums/message-status.enum';

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    hasNewMessages: Subject<number>;

    constructor(private http: HttpClient) {
        this.hasNewMessages = new Subject();
    }

    getList(): Observable<Message[]> {
        return this.http.get<Paginated>(EnvironmentUtils.env.api + 'messages')
            .pipe(map(data => {

                const messages: Message[] = data.data;
                const newMessages = messages.filter((message: Message) => message.status === MessageStatusEnum._new && message.sentByType !== 'client').length;

                this.hasNewMessages.next(newMessages);

                return messages;
            }));
    }

    getNew(): Observable<Message[]> {
        return this.http.get<Paginated>(EnvironmentUtils.env.api + 'messages?status=new')
            .pipe(map(data => data.data));
    }

    sendMessage(content: string): Observable<Message> {
        return this.http.post<Message>(EnvironmentUtils.env.api + `messages`, {content: content});
    }

    read(message: Message): Observable<Message> {
        return this.http.put<Message>(EnvironmentUtils.env.api + `messages/` + message.id, {status: MessageStatusEnum.read});
    }
}
